(function(){

  'use strict';

    //*****************//
    // Data that this directive needs
    // -----------------
    // 
    //*****************//

    // 
    // }

  function pxCheckbox($timeout, $filter, $window) {
    return {
      restrict: 'EA',
      scope: {
        checkboxData: '=checkboxData',
        value: '=value',
        required: '=required',
        callback: '&callback'
      },
      templateUrl: 'app/directives/checkbox/checkbox.template.html',
      link: function(scope) {

        scope.data = scope.checkboxData;

        scope.changeCheckboxValue = function() {
          scope.callback({value: scope.data.value});
        }

        function init() {
          scope.callback({value: scope.data.value});
        }

        init();

      }
    };
  }

  pxCheckbox.$inject = ['$timeout', '$filter', '$window'];

  angular
    .module('printix-admin')
    .directive('pxCheckbox', pxCheckbox);

})();
